import React, { useState, useMemo } from "react";
import Modal from "components/modal";
import { FiDownload, FiExternalLink, FiCopy } from "react-icons/fi";
import Button from "components/button";

export function ImagePreview({ url, alt = "item" }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);

  const fileName = useMemo(() => {
    if (!url) return "image";
    return decodeURIComponent(url.split("/").pop()?.split("?")[0] || "image");
  }, [url]);

  const handleDownload = () => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleCopyUrl = () => {
    if (url) navigator.clipboard.writeText(url);
  };

  if (!url) return <span className="text-gray-400">—</span>;

  return (
    <>
      {/* Thumbnail */}
      <img
        src={url}
        alt={alt}
        className="h-12 w-12 cursor-pointer rounded object-cover ring-1 ring-gray-200 transition hover:ring-gray-400"
        onClick={() => setOpen(true)}
        onError={() => setError(true)}
        style={{ visibility: error ? "hidden" : "visible" }}
      />

      {/* Modal */}
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        showCloseButton
        closeOnOverlayClick
        className="max-w-lg p-4"
      >
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Image Preview
        </h2>

        {/* Full Image */}

        <div className="relative w-full  p-4 lg:p-5">
          <img
            src={url}
            alt={alt}
            className="h-[40vh] w-full rounded-lg object-contain"
            onError={() => setError(true)}
            style={{ visibility: error ? "hidden" : "visible" }}
          />

          {error && (
            <span className="text-gray-400 dark:text-gray-300">
              Failed to load image
            </span>
          )}
          <div className="flex flex-col">
            <div className="mt-6 flex items-center justify-end gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button onClick={handleDownload}>
                <FiDownload /> {"  "}Download
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
